import { render } from "./BankDetails.vue?vue&type=template&id=f4573f64&scoped=true"
import script from "./BankDetails.vue?vue&type=script&lang=js"
export * from "./BankDetails.vue?vue&type=script&lang=js"

import "./BankDetails.vue?vue&type=style&index=0&id=f4573f64&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4573f64"]])

export default __exports__